import React from 'react'

import useStyles from '../UserJoinedAlert/styles'

const EmptyConversationAlert = ({ v2 }) => {
  const classes = useStyles({ v2 })

  return (
    <div
      className={classes.root}
      style={{ fontStyle: 'italic', opacity: '0.7' }}
    >
      Empty conversation
    </div>
  )
}

export default EmptyConversationAlert
